// extracted by mini-css-extract-plugin
export default {"button":"CommonStyles_button__ddfhY"};